import React from "react";
import "animate.css";

const Realisations = () => {
  const realisations = [
    {
      id: 1,
      src: "/images/docia.png",
      desc: "Doc IA est une solution conçue pour faciliter l’accès rapide à un diagnostic médical grâce à d’intelligence artificielle",
    },
    {
      id: 2,
      src: "/images/seg.png",
      desc: "Ce projet consiste en la création d’un site moderne pour une agence spécialisée dans le BTP.",
    },
    {
      id: 3,

      src: "/images/kinsam.png",
      desc: "Conception et réalisation d'une application web pour une agence d'assurance.",
    },
    {
      id: 4,
      src: "/images/dwa.png",
      desc: "Conception d’un site web professionnel pour une agence combinant des services en BTP et en architecture.",
    },
    {
      id: 5,
      src: "/images/home.png",
      desc: "Application web dédiée à la gestion des incidents informatique",
      // src: "/images/accueil.png",
      // desc: "Application desktop dédiée à la réparation, la maintenance informatique et la création de site web.",
    },
    {
      id: 6,
      src: "/images/accueil1.png",
      desc: "Conception et réalisation d'une application web la réparation, la maintenance informatique et la création de site web.",
    },
  ];

  return (
    <section
      id="realisations"
      className="bg-gray-100 py-10 px-4 sm:px-6 lg:px-8"
    >
      <h2 className="text-[#03224C] text-3xl sm:text-4xl md:text-5xl font-bold text-center mb-8 sm:mb-12">
        Mes Réalisations
      </h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 sm:gap-8">
        {realisations.map((realisation, index) => (
          <div
            key={realisation.id}
            className="relative group overflow-hidden rounded-lg shadow-lg cursor-pointer"
          >
            <img
              src={realisation.src}
              alt={`Réalisations ${realisation.id}`}
              className="w-full h-48 sm:h-56 md:h-64 object-cover transition-transform duration-300 ease-in-out transform group-hover:scale-110"
            />
            {/* Description text */}
            <div
              className={`absolute inset-0 bg-black bg-opacity-70 text-white flex justify-center items-center text-center opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate__animated ${
                index === 0
                  ? "animate__zoomIn"
                  : index === 1
                  ? "animate__zoomIn"
                  : index === 2
                  ? "animate__zoomIn"
                  : index === 3
                  ? "animate__flipInX"
                  : index === 4
                  ? "animate__lightSpeedInLeft"
                  : "animate__zoomIn"
              }`}
            >
              <p className="text-sm sm:text-base md:text-xl font-semibold">
                {realisation.desc}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Realisations;
